import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../../helpers';
import { ScriptLoaderService } from '../../../../_services/script-loader.service';


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.	m-container.m-container--responsive.m-container--xxl.m-page__container.m-body",
    templateUrl: "./aside-left-display-disabled.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideLeftDisplayDisabledComponent implements OnInit {


    constructor() {

    }
    ngOnInit() {

    }

}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/aside-left-display-disabled/aside-left-display-disabled.component.ts